var _path, _circle, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPairingGeneral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M24.9 34h2c2.5 0 4.6-2.1 4.6-4.6V12.2c0-2.5-2.1-4.6-4.6-4.6H14.5c-2.5 0-4.6 2.1-4.6 4.6v5.3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 15.4,
    cy: 13.4,
    r: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M25.6 13.4H20M8.8 30.1s-.8.4-1.8-.6l-2.8-2.8c-1.6-1.6-.6-2.3.6-3.6s2-2.2 3.6-.6l2.8 2.8c.9.9.6 1.8.6 1.8M14.9 30.1s.8-.4 1.7.6l2.8 2.8c1.6 1.6.6 2.3-.6 3.6-1.3 1.3-2 2.2-3.6.6l-2.8-2.8c-.9-.9-.6-1.7-.6-1.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M14.6 32.8L9 27.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M15.5 20.1h10.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPairingGeneral);
export default __webpack_public_path__ + "static/media/pairingGeneral.7b88fc5a74c7c320f31eb4894f070f3b.svg";
export { ForwardRef as ReactComponent };